module.exports = __webpack_public_path__ + "images/emoji/bank.653485aeca8cbe0dddbb.png";